import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { CheckCircle, Loader } from "lucide-react";

function PaymentSuccess() {
  const [message, setMessage] = useState("Processing your payment...");
  const [loading, setLoading] = useState(true);
useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const txnid = params.get("txnid") || "";

    if (!txnid) {
      window.location.href = "/";
      return;
    }

    // ✅ DB already updated by PHP — just show success
    setLoading(false);
    setMessage("Payment Activated!");

    Swal.fire({
      icon: "success",
      title: "Plan Activated ",
      text: "Your Premium plan is now active for 3 months!",
      confirmButtonColor: "#22c55e"
    }).then(() => {
      window.location.href = "/";
    });

}, []);


  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {loading ? (
          <>
            <Loader size={60} className="spin" />
            <h2 style={styles.title}>Processing Payment</h2>
            <p style={styles.subtitle}>
              Please wait while we activate your plan.
            </p>
          </>
        ) : (
          <>
            <CheckCircle size={70} color="#22c55e" />
            <h2 style={styles.title}>{message}</h2>
            <p style={styles.subtitle}>
              Redirecting you to the homepage...
            </p>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f7fb",
    fontFamily: "Arial, sans-serif"
  },

  card: {
    background: "#fff",
    padding: "50px",
    borderRadius: "14px",
    textAlign: "center",
    width: "420px",
    boxShadow: "0 10px 35px rgba(0,0,0,0.08)"
  },

  title: {
    fontSize: "26px",
    marginTop: "20px",
    marginBottom: "10px",
    fontWeight: "600"
  },

  subtitle: {
    color: "#6b7280",
    fontSize: "15px"
  }
};

export default PaymentSuccess;